import React, { useEffect } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import {
    Typography,
    Variant,
    Grid,
    ColorHex,
    ContainerMui,
    Spacer
} from '../../styles';

import {
    InfoEconomie,
    RepartitionDonut,
    PaiementSelect,
    FrequenceSelect,
    DetailsPaiementBar
} from './components';
import { ClavardageContexte, setContexteClavardage } from '../../components';
import { ProgressBar } from './../../components';
import { Backdrop, makeStyles } from '@material-ui/core';

interface IModalitesProps {
    paiementData: any;
    frequencesData: any;
    typePret: string;
    coutAssuranceModalDisplayed: boolean;
    showLoadingCalculations: boolean;
}

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        position: 'absolute',
        color: '#2f2f2f'
    },
    typePretTitre: {
        fontSize: '24px !important'
    },
    typePret: {
        fontSize: '20px !important'
    }
}));

export const Modalites: React.FC<IModalitesProps> = ({
    paiementData,
    frequencesData,
    typePret,
    coutAssuranceModalDisplayed,
    showLoadingCalculations
}) => {
    const [t] = useTranslation('Modalites');
    const isMobile = useMediaQuery('(max-width:640px)');

    const classes = useStyles();

    useEffect(() => {
        setContexteClavardage(ClavardageContexte.MODALITES);

        return () => {
            // Réinitialisation du contexte de clavardage
            setContexteClavardage(ClavardageContexte.DEFAULT);
        };
    }, []);

    return (
        <Grid>
            <ProgressBar
                subtitle={t('title')}
                subtitleDataTestId="page_modalites_titre"
            />
            <Box maxWidth={isMobile ? '100%' : '70%'}>
                <Typography
                    dataTestId="page_modalites_instructions"
                    variant={Variant.p}
                    marginBottom="1.5rem"
                >
                    {t('ajusterPaiementTexte')}
                </Typography>
            </Box>

            <ContainerMui
                padding={isMobile ? '1rem' : '1.5rem'}
                spacerDistance={6}
            >
                {/* Header type pret */}
                <h3>
                    <span className={classes.typePretTitre}>
                        {t('typePretTitre')}
                    </span>{' '}
                    <br />
                    <Spacer all={4} sm={2} />
                    <span className={classes.typePret}>{typePret}</span>
                </h3>

                <Box position={'relative'}>
                    {/* Spinner sur les calculs section droite */}
                    <Backdrop
                        className={classes.backdrop}
                        open={showLoadingCalculations}
                    >
                        <Box display="block" position="absolute">
                            <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                justifyContent="center"
                                margin="0 1.625rem"
                                borderRadius="1rem"
                                padding="1.225rem"
                                paddingRight="2.375rem" // compensation for dsd-loading box
                                bgcolor={ColorHex.lightWhite}
                                style={{
                                    userSelect: 'none',
                                    gap: '0.625rem'
                                }}
                            >
                                {/* @ts-ignore */}
                                <dsd-loading size="xs" />
                                <b>{t('loadingText')}</b>
                            </Box>
                        </Box>
                    </Backdrop>

                    {showLoadingCalculations ? (
                        <Box height={'150px'}></Box>
                    ) : (
                        <Box>
                            <FrequenceSelect />
                            <PaiementSelect />
                            {/* Donut! */}
                            <RepartitionDonut />
                            {/* Economie */}
                            <InfoEconomie />

                            {/* DetailsPaiementBar */}
                            <DetailsPaiementBar
                                paiementData={paiementData}
                                frequencesData={frequencesData}
                                shouldShowCoutAssuranceModal={
                                    coutAssuranceModalDisplayed
                                }
                            />
                        </Box>
                    )}
                </Box>
            </ContainerMui>
        </Grid>
    );
};
